import { useDispatch } from 'react-redux';
import { toggleMobileSidebar } from '../../store/slices/uiSlice';
import { Icon } from '../ui/Icon';

export default function Topbar() {
  const dispatch = useDispatch();

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center gap-3 border-b border-neutral-200 bg-white px-4 lg:px-6">
      {/* Mobil menü butonu — spine app içinde iframe olarak çalışırken
          sadece küçük ekranlarda gösterilir */}
      <button
        type="button"
        onClick={() => dispatch(toggleMobileSidebar())}
        className="rounded-md p-2 text-neutral-500 hover:bg-neutral-100 lg:hidden"
        aria-label="Menü"
      >
        <Icon name="menu" className="h-5 w-5" />
      </button>
    </header>
  );
}
